import { defaultMeta } from './defaultMeta.constant'

export const notificationTransformerResponse = <T>() => ({ data: [] as T, meta: { ...defaultMeta, not_seen_count: 0 } })
